import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { tap } from 'rxjs'
import { EnvironmentConstants } from '../generated/generated'
import { AppConfig } from '../models/app-config.model'
@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  constructor(private http: HttpClient) {}
  private appConfig: AppConfig

  public loadAppConfiguration() {
    return this.http.get('assets/app.settings.json').pipe(
      tap((data: AppConfig) => {
        this.appConfig = data
      })
    )
  }

  public getApiUrl() {
    if (this.isConfigLoaded()) {
      return this.appConfig.applicationSettings.apiUrl
    }
  }

  public getBuildName() {
    if (this.isConfigLoaded()) {
      return this.appConfig.applicationSettings.buildName
    }
  }

  public getAuthorityLocation() {
    if (this.isConfigLoaded()) {
      return this.appConfig.applicationSettings.authorityLocation.replace(/^\/*|\/*$/gm, '') + '/#/account'
    }
  }

  public getApplicationName() {
    if (this.isConfigLoaded()) {
      return this.appConfig.applicationSettings.applicationName
    }
  }

  public isProduction() {
    if (this.isConfigLoaded()) {
      return this.appConfig.applicationSettings.environment == EnvironmentConstants.production
    }
  }

  public isLocalDevelopment() {
    if (this.isConfigLoaded()) {
      return this.appConfig.applicationSettings.environment == EnvironmentConstants.localDevelopment
    }
  }

  public areDetailedErrorsEnabled() {
    if (this.isConfigLoaded()) {
      return this.appConfig.applicationFeatureFlags.enableDetailedExceptions
    }
  }

  public getEnvironmentName() {
    if (this.isConfigLoaded()) {
      return this.appConfig.applicationSettings.environment
    }
  }

  public getApiUrlWithEndpoint(endpoint: string) {
    let baseUrl = this.getApiUrl()

    //strip the baseUrl if it happens to be in there on accident.
    endpoint = endpoint.replace(baseUrl, '')

    //Strip leading and trailing slashes.
    baseUrl = baseUrl.replace(/^\/*|\/*$/gm, '')
    endpoint = endpoint.replace(/^\/*|\/*$/gm, '')

    return `${baseUrl}/${endpoint}`
  }

  private isConfigLoaded() {
    if (!this.appConfig) {
      return false
    }
    return true
  }
}
